export const roleType = 'UserRole';

export interface IRole {
  id: string;
  name: string;
  commentsColor: string;
  commentsColorPriority: number | null;
  permission: string;
  permissions: string[];
  users: number | null;
  numericId: number | null;
  roleType: string | null;
}

export interface UserRole {
  commentsColor: string;
  commentsColorPriority: null | string;
  id: string;
  name: string;
  permissions: string[];
  numericId: number;
  priority: number;
}

export interface IPermission {
  permissions: string[];
  userId: string;
}